import React from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import AllianzLogo from "../../../../../assets/AllianzLogo";
import "./DashboardTopBar.scss";

interface DashboardTopBarI {
  /** «In collaborazione con Allianz» (IT). */
  showAllianz: boolean;
  phone?: string;
  /** Sin menú lateral (funnel native) no hay botón de menú. */
  onOpenMenu?: () => void;
  menuOpen?: boolean;
  /** "always": sin menú lateral el logo de Life5 va en la barra también en desktop. */
  brand?: "mobile" | "always";
}

/**
 * Barra superior del Dashboard cuando es una app con su propio marco (Portal
 * Cliente native): sustituye a la navbar global, que duplicaba el logo y se
 * solapaba con el menú lateral. Va sobre el mismo fondo que el contenido, sin
 * cortes. En móvil lleva además el botón del menú y el logo (el menú está oculto).
 */
const DashboardTopBar = ({
  showAllianz,
  phone,
  onOpenMenu,
  menuOpen = false,
  brand = "mobile",
}: DashboardTopBarI) => (
  <div className="dashboard-topbar">
    <div className="dashboard-topbar__start">
      {onOpenMenu && !menuOpen && (
        <button
          type="button"
          className="dashboard-topbar__menu"
          onClick={onOpenMenu}
          aria-label="Menu"
        >
          <GlobalIcon iconName="MenuIcon" size="XS" color="#374151" />
        </button>
      )}
      <span
        className={`dashboard-topbar__brand ${
          "always" === brand ? "dashboard-topbar__brand--always" : ""
        }`}
      >
        <GlobalIcon iconName="LogoLife5Blue" size="M" />
      </span>
      {showAllianz && (
        <span className="dashboard-topbar__partner" data-testid="dashboard-allianz">
          <AllianzLogo />
        </span>
      )}
    </div>
    {phone && (
      <a className="dashboard-topbar__phone" href={`tel:${phone.replace(/\s/g, "")}`}>
        <GlobalIcon iconName="PhoneIcon" size="XS" color="currentColor" />
        <span className="dashboard-topbar__phoneNumber">{phone}</span>
      </a>
    )}
  </div>
);

export default DashboardTopBar;
